export default "__VITE_ASSET__2hb2QA_1__"